import React, { useState, useEffect, useRef } from "react"

export default function SearchChat() {
  const [query, setQuery] = useState("")
  const [conversations, setConversations] = useState([])
  const [loading, setLoading] = useState(false)

  const handleSearch = async () => {
    if (!query.trim()) return

    const currentQuery = query
    setQuery("")
    setLoading(true)

    // Add user query first (optimistic UI)
    setConversations(prev => [...prev, { type: "user", text: currentQuery }])

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_WEB_API_URL
        }/pdf/search?keyword=${encodeURIComponent(currentQuery)}`
      )
      const data = await response.json()

      setConversations(prev => [
        ...prev,
        {
          type: "bot",
          query: currentQuery,
          results: data,
        },
      ])
    } catch (error) {
      setConversations(prev => [
        ...prev,
        {
          type: "bot",
          query: currentQuery,
          error: "Search failed",
        },
      ])
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="flex-grow-1 overflow-auto p-3">
            {conversations.map((item, index) => (
              <div key={index} className="mb-3">
                {item.type === "user" && (
                  <div className="text-end fw-bold">{item.text}</div>
                )}

                {item.type === "bot" && (
                  <div className="bg-light rounded p-3 mt-2">
                    {item.error && <p>{item.error}</p>}

                    {Array.isArray(item.results) && item.results.length > 0 ? (
                      item.results.map((r, i) => (
                        <div key={i} className="border-bottom pb-2 mb-2">
                          <strong>{"Refrence : " + r.FileName}</strong>
                          <p>{"Page :" + r.PageNumber}</p>
                          <p>{r.Snippet}</p>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted">No results found</div>
                    )}
                  </div>
                )}
              </div>
            ))}

            {loading && <div className="text-muted">Searching…</div>}
          </div>

          <div className="border-top p-3 bg-white">
            <div className="input-group">
              <input
                className="form-control"
                value={query}
                onChange={e => setQuery(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSearch()}
                placeholder="Search PDFs..."
              />
              <button className="btn btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
